export const licenseAssignationKey = 'getLicenseAssignation';
